/**
 * Pure helpers for the project-grouping cookie. Safe to import from middleware
 * (Edge Runtime) and any server/client code — no React, no browser APIs.
 *
 * The cookie mirrors the `usePersistedState` localStorage key for projects
 * grouping so middleware can rewrite `/files` → `/grouped-projects?groupBy=…`
 * during the initial post-login redirect, before any client code mounts.
 */

export const PROJECT_GROUPING_COOKIE_PREFIX = "x-project-grouping";

export function getProjectGroupingCookieName(orgId: string, teamId: string): string {
  return `${PROJECT_GROUPING_COOKIE_PREFIX}_${orgId}_${teamId}`;
}
